import React from "react";
import "./Upcoming.css";
import aboutHeroImage from '../../img/about-us-banner.jpg'; // Replace with the correct image path
import Footer from "../home-page/Footer";



import { FaCalendarAlt, FaMapMarkerAlt, FaInfoCircle, FaPhone, FaEnvelope } from "react-icons/fa";
import about11 from "../../img/about-info.png";

import savarkar from "../../img/savarkar.jpg";
import mp from "../../img/MP.jpg";

const Upcoming = () => {
  const events = [
    {
      title: "वातंयवीर सावरकर शषे - अदं मान वारसा सहल (Swatantryaveer special Andaman heritage tour)",
      date: "March 15-20, 2025",
      location: "Andaman Islands",
      description: "Join us for an immersive heritage tour exploring the rich history, culture, and natural beauty of Andaman Islands.",
      image: savarkar,
    },
    {
      title: "Majestic M.P - South",
      date: "April 10-15, 2025",
      location: "Madhya Pradesh",
      description: "Experience the majestic landscapes and explore the cultural heritage of Madhya Pradesh's southern regions.",
      image: mp,
    },
  ];

  return (
    <>
     <div className="about-hero-section">
      <img src={aboutHeroImage} alt="About Us" className="about-hero-image" />
      <div className="about-hero-overlay"></div>
      <div className="about-hero-content">
        <h1>Upcoming Events</h1>
        <div className="breadcrumb">
          {/* <span>Pages</span> &gt; <span>About Us</span> */}
        </div>
      </div>
    </div>
    <section className="upcoming-section">
    <div className="text-content">
      <h2>Explore Historic Wonders !</h2>
      <p>
        Explore these enriching events designed to take you on cultural and historical journeys.
      </p>
    </div>
    <div className="image-container">
      <img src={about11} alt="Upcoming Events" />
    </div>
  </section>
    <div className="upcoming-container">
      {/* Left Section */}
     
      <div className="left-section">
        

        <section className="events-section">
          {events.map((event, index) => (
            <div key={index} className="event-card">
              <div className="event-image">
                <img src={event.image} alt={event.title} />
              </div>
              <div className="event-details">
                <h3>{event.title}</h3>
                <p className="event-date">
                  <span className="icon-border"><FaCalendarAlt /></span> {event.date}
                </p>
                <p className="event-location">
                  <span className="icon-border"><FaMapMarkerAlt /></span> {event.location}
                </p>
                <p className="event-description">{event.description}</p>
                <button className="read-more">Read More</button>
              </div>
            </div>
          ))}
        </section>
      </div>

      {/* Right Section */}
      <div className="right-section">
  <div className="static-content">
    <h4>About These Tours</h4>
    <p className="info-upcoming">
      These tours are carefully curated to provide a unique cultural and historical experience. 
      From exploring the iconic Andaman Islands to the rich landscapes of Madhya Pradesh, each event is 
      designed to inspire and educate.
    </p>

    {/* Additional Tour Details */}
    <div className="additional-info">
      <div className="info-item">
        <FaInfoCircle className="info-icon" />
        <p>Rich Historical Narratives</p>
      </div>
      <div className="info-item">
        <FaPhone className="info-icon" />
        <p>Contact Us Anytime</p>
      </div>
      <div className="info-item">
        <FaEnvelope className="info-icon" />
        <p>Stay Updated via Email</p>
      </div>
    </div>
  </div>

  {/* New Content Section */}
  <div className="additional-content">
    <h4>Why Choose Us?</h4>
    <p>
      Our tours are guided by experts who are passionate about sharing their knowledge of the history and culture 
      of each destination. Whether you're a history buff or someone looking to explore new horizons, these tours 
      offer an enriching experience that goes beyond the ordinary.
    </p>

    <h4>Important Information</h4>
    <ul>
      <li>Ensure your passport and other travel documents are ready for the tour.</li>
      <li>Our tours include guided trips, meals, and local transportation.</li>
      <li>Seats are limited, so book early to secure your spot!</li>
    </ul>

    <h4>Contact Information</h4>
    <p>If you have any questions or need assistance, please feel free to contact us:</p>
    <p>Phone: +91 9175 917553</p>
    <p>Email: info@waisan.in
    </p>
  </div>
</div>

      
    </div>
    <Footer/>
    </>
  );
};

export default Upcoming;
